export const SortByIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M4.27995 2.00001C4.0741 2.00001 3.89038 2.1083 3.77004 2.27775L1.19223 5.22346C0.935922 5.51635 0.935922 5.99123 1.19223 6.28412C1.44855 6.57701 1.86411 6.57701 2.12042 6.28412L3.62362 4.5664V13.25C3.62362 13.6642 3.91747 14 4.27995 14C4.64243 14 4.93628 13.6642 4.93628 13.25V4.5559L6.45261 6.28864C6.70892 6.58153 7.12449 6.58153 7.3808 6.28864C7.63711 5.99574 7.63711 5.52087 7.3808 5.22798L4.74821 2.21967C4.61921 2.07227 4.44901 1.99905 4.27995 2.00001ZM4.27995 2.00001C4.27966 2.00001 4.28024 2.00001 4.27995 2.00001V2.00001ZM11.7201 14C11.9259 14 12.1096 13.8917 12.23 13.7222L14.8078 10.7765C15.0641 10.4836 15.0641 10.0088 14.8078 9.71588C14.5515 9.42299 14.1359 9.42299 13.8796 9.71588L12.3764 11.4336L12.3764 2.75C12.3764 2.33579 12.0825 2 11.7201 2C11.3576 2 11.0637 2.33579 11.0637 2.75L11.0637 11.4441L9.54739 9.71136C9.29108 9.41847 8.87551 9.41847 8.6192 9.71136C8.36289 10.0043 8.36289 10.4791 8.6192 10.772L11.2518 13.7803C11.3808 13.9277 11.551 14.001 11.7201 14ZM11.7201 14C11.7198 14 11.7203 14 11.7201 14V14Z'
        fill='#122D5C'
      />
    </svg>
  )
}
